import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { TranslateService } from '@ngx-translate/core';
import { Features } from '@ordersnproducts/features';
import {
  CX_INPUT_DATE_LABEL_APPLY_TOKEN,
  CX_INPUT_DATE_LABEL_CANCEL_TOKEN,
} from 'app/shared/cx-ui/cx-input-date/cx-input-date.config';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const cxDateLabelsControlButtonsProvider = [
  {
    provide: CX_INPUT_DATE_LABEL_APPLY_TOKEN,
    deps: [FeatureToggleService, TranslateService],
    useFactory: (featureToggle: FeatureToggleService, ts: TranslateService) => {
      return of('').pipe(
        switchMap(() => {
          const controlButtons = featureToggle.isFeatureEnabled(Features.DATE_AND_TIME_CTRL_BTNS_UI);
          const labelApply = controlButtons
            ? ts.instant('views.specifications.grouping_delivery_date.button.labelApply')
            : undefined;
          return of(labelApply);
        }),
      );
    },
  },
  {
    provide: CX_INPUT_DATE_LABEL_CANCEL_TOKEN,
    deps: [FeatureToggleService, TranslateService],
    useFactory: (featureToggle: FeatureToggleService, ts: TranslateService) => {
      return of('').pipe(
        switchMap(() => {
          const controlButtons = featureToggle.isFeatureEnabled(Features.DATE_AND_TIME_CTRL_BTNS_UI);
          const labelCancel = controlButtons
            ? ts.instant('views.specifications.grouping_delivery_date.button.labelCancel')
            : undefined;
          return of(labelCancel);
        }),
      );
    },
  },
];
